import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { Link, useLocation, useParams } from 'react-router-dom';
import ProfileBackground from 'assets/images/background/profile-bg.jpg';
import EleveService from '../../services/EleveService';
import SalleDeClasseService from '../../services/SalledeclasseService';

const BulletinnoteProfileLayout = (props) => {
	const { salledeclasseId, eleveId } = useParams();

	const location = useLocation();
	const [Bulletinnote, setBulletinNote] = useState(null);
	const [eleve, setEleve] = useState(null);
	const [salleDeClasse, setSalleDeClasse] = useState(null);

	useEffect(() => {
		// Fetching student details directly
		EleveService.getEleve(eleveId)
			.then((res) => {
				setEleve(res.data);
			})
			.catch((error) => {
				console.error('Error fetching student data', error);
			});
	}, [eleveId]);

	useEffect(() => {
		const fetchSalleDeClasse = async () => {
			try {
				const response = await SalleDeClasseService.getSalledeclasse(
					salledeclasseId
				);
				setSalleDeClasse(response.data);
			} catch (error) {
				console.error('Error fetching salle de classe data', error);
			}
		};

		fetchSalleDeClasse();
	}, [salledeclasseId]);

	function formatIntituleClasse(value) {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	}

	const shouldDisplayInterface =
		eleve &&
		eleve.salledeclasse &&
		eleve.salledeclasse.toString() === salledeclasseId;

	return (
		<Fragment>
			<section className="pt-5 pb-5">
				<Container>
					{shouldDisplayInterface && (
						<>
							{/* User info */}
							<Row className="align-items-center">
								<Col xl={12} lg={12} md={12} sm={12}>
									<div
										className="pt-16 rounded-top-md"
										style={{
											background: `url(${ProfileBackground})`,
											backgroundRepeat: 'no-repeat',
											backgroundSize: 'cover'
										}}
									>
										{' '}
									</div>
									<Card className="px-4 pt-2 pb-4 rounded-0 rounded-bottom shadow-sm">
										<div className="d-flex align-items-end justify-content-between  ">
											<div className="d-flex align-items-center">
												<div className="lh-1">
													<h3 className="mb-0 text-uppercase">
														{eleve?.nom || ''} {eleve?.prenom || ''}
													</h3>
													<p className="mb-0 d-block text-uppercase">
														{salleDeClasse
															? formatIntituleClasse(
																	salleDeClasse.intitule_classe
															  ).toUpperCase()
															: ''}
													</p>
												</div>
											</div>
											<div>
												<Link
													to={`/pedagogie/notes/${salledeclasseId}/eleves`}
													className={`btn btn-outline-dark btn-sm d-none d-md-block`}
												>
													Retour à la liste des élèves
												</Link>
											</div>
										</div>
									</Card>
								</Col>
							</Row>

							{/* Content */}
							<Row className="mt-0 mt-md-4">
								<Col lg={3} md={4} sm={12}>
									<Navbar
										expand="lg"
										className="navbar navbar-expand-md navbar-light shadow-sm mb-4 mb-lg-0 sidenav"
									>
										<Link
											className="d-xl-none d-lg-none d-md-none text-inherit fw-bold fs-5 float-start py-1"
											to="#"
										>
											Menu
										</Link>
										<Navbar.Toggle
											aria-controls="basic-navbar-nav"
											className="p-0 focus-none border-0"
											label="Responsive Menu"
										>
											<span
												className="navbar-toggler d-md-none icon-shape icon-sm rounded bg-primary p-0 text-white float-end"
												data-bs-toggle="collapse"
												data-bs-target="#sidenav"
												aria-controls="sidenav"
												aria-expanded="false"
												aria-label="Toggle navigation"
											>
												<span className="fa-solid fa-menu"></span>
											</span>
										</Navbar.Toggle>

										<Navbar.Collapse id="basic-navbar-nav">
											<Nav
												className="me-auto flex-column"
												as="ul"
												activeKey="0"
											>
												<Nav.Item className="navbar-header mt-4" as="li">
													Bulletinnote
												</Nav.Item>
												<Nav.Item as="li">
													{
														<Link
															className={`nav-link ${
																location.pathname ===
																`/pedagogie/notes/${salledeclasseId}/eleves/${eleveId}`
																	? 'active'
																	: ''
															}`}
															to={`/pedagogie/notes/${salledeclasseId}/eleves/${eleveId}`}
														>
															<i
																className={`fa-solid fa-file-invoice nav-icon`}
															></i>
															Remplir le Bulletin de notes
														</Link>
													}
												</Nav.Item>
												<Nav.Item as="li">
													{
														<Link
															className={`nav-link ${
																location.pathname ===
																`/pedagogie/notes/${salledeclasseId}/eleves/${eleveId}/print`
																	? 'active'
																	: ''
															}`}
															to={`/pedagogie/notes/${salledeclasseId}/eleves/${eleveId}/print`}
														>
															<i className={`fa-solid fa-print nav-icon`}></i>
															Imprimer le Bulletin Trimestriel
														</Link>
													}
												</Nav.Item>
												<Nav.Item as="li">
													{
														<Link
															className={`nav-link ${
																location.pathname ===
																`/pedagogie/notes/${salledeclasseId}/eleves/${eleveId}/annual-report/print`
																	? 'active'
																	: ''
															}`}
															to={`/pedagogie/notes/${salledeclasseId}/eleves/${eleveId}/annual-report/print`}
														>
															<i className={`fa-solid fa-print nav-icon`}></i>
															Imprimer le Bulletin Annuel
														</Link>
													}
												</Nav.Item>
											</Nav>
										</Navbar.Collapse>
									</Navbar>
								</Col>

								<Col lg={9} md={8} sm={12}>
									{props.children}
								</Col>
							</Row>
						</>
					)}
				</Container>
			</section>
		</Fragment>
	);
};
export default BulletinnoteProfileLayout;
